import { useDispatch, useSelector } from "react-redux"
import { selectTranslations } from "../../../App/i18n/i18nSlice"
import Header from "../../Shared/Header/Header"
import Footer from "../../Shared/Layout/Footer"
import IndividualProfileCard from "../../Shared/Components/IndividualProfileCard"
import MainLayout from "../../Shared/Layout/MainLayout"
import NewestMembersCard from "../../Shared/NewestMembers/NewestMemberCard"
import RoomDropdown from "../../Shared/Components/RoomDropdown"
import SponsorCard from "../../Shared/Components/SponsorCard"
import OrganizationDashboardFeed from "./OrganizationDashboardFeed"
import ModalGroup from "../../Shared/Components/ModalGroup"
import { RoleType, StorageKey } from "../../../App/enums"
import { useLocation, useNavigate, useParams } from "react-router"
import { useEffect, useState } from "react"
import SessionService from "../../../App/SessionService"
import { RootState } from "../../../App/store"
import BackgroundWrapper from "../../Shared/Components/BackgroundWrapper"
import { SearchIcon } from "../../Shared/Components/SvgIcons"
import { setModalData } from "../../Shared/SharedSlices/ModalSlice"
import { PatchOrganizationTutorialProgressRequest } from "../OrganizationSettings/OrganizationAccountServiceRequest"
import { setOrganizationData } from "../../Shared/SharedSlices/OrganizationsSlice"

function OrganizationDashboardScreen() {
    const organization = useSelector((state: RootState) => state.organizationsSlice.organizationSlice.organization)
    const translation = useSelector(selectTranslations)
    const dispatch = useDispatch()
    const { id } = useParams()
    const location = useLocation()
    const navigate = useNavigate()
    const role = useSelector((state: RootState) => state.rolesSlice.RolesSlice.roles)
    const [hasArticleCard] = useState(false)

    const onSeeAllEventsClick = () => {
        switch (role) {
            case RoleType.ORGANIZATION:
                navigate(`/all-premium-events/${id}`)
                break
            case RoleType.USER:
                navigate(`/all-premium-events`)
                break
            default:
                break
        }
    }

    useEffect(() => {
        const initializeOnboarding = async () => {
            SessionService.setItem(StorageKey.organizationId, id!)

            const shouldStartOrgOnboarding = new URLSearchParams(location.search).get("start_org_onboarding") === "1"

            if (shouldStartOrgOnboarding) {
                if (organization.id && organization.tutorial_progress !== 1) {
                    await PatchOrganizationTutorialProgressRequest(organization.id, 1)
                    dispatch(setOrganizationData({ ...organization, tutorial_progress: 1 }))
                }
                return
            }

            if (organization.tutorial_progress === 0) {
                dispatch(setModalData({ open: true, showTutorial: true }))
            }
        }

        initializeOnboarding()
    }, [dispatch, id, location.search, organization])

    return (
        <BackgroundWrapper>
            <Header />
            <MainLayout
                leftPanelFirstComponent={<IndividualProfileCard />}
                leftPanelSecondComponent={<RoomDropdown type={RoleType.ORGANIZATION} />}
                leftPanelThirdComponent={null}
                RightPanelSecondComponent={translation.newsMembersText}
                RightPanelThirdComponent={<NewestMembersCard />}
                RightPanelForthComponent={
                    <div className="main-layout__sponsored-title">
                        {translation.sponsoredText}
                        <div onClick={onSeeAllEventsClick} className="main-layout__sponsored-icon">
                            <SearchIcon color="dark-blue" />
                        </div>
                    </div>
                }
                RightPanelFifthComponent={<SponsorCard />}
                overflowModifier={true}
                isDashboad={hasArticleCard}
            >
                <OrganizationDashboardFeed hasArticleCard={hasArticleCard} />
            </MainLayout>
            <Footer />
            <ModalGroup />
        </BackgroundWrapper>
    )
}

export default OrganizationDashboardScreen
